import QuestionAnswer from "@mui/icons-material/QuestionAnswer";
import { Link } from "@mui/material";
import { openFrontChatWithAiBotBypass } from "util/openFrontChat";

const SUPPORT_LINK_SX = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  fontWeight: 400,
  fontSize: 14,
  gap: 1,
  border: "none",
  background: "none",
  cursor: "pointer",
  fontFamily: "inherit",
  py: 0.5,
} as const;

/**
 * Opens Front chat with the Scout escalation source. Shared by the full-page
 * empty state and the popover footer so both surfaces use the same CTA.
 */
export function ScoutSupportChatLink() {
  return (
    <Link
      component="button"
      type="button"
      onClick={openFrontChatWithAiBotBypass}
      sx={SUPPORT_LINK_SX}
    >
      <QuestionAnswer sx={{ fontSize: 20 }} />
      Need to talk to a human? Encamp Support is always available
    </Link>
  );
}
